var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResultGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9989 80.9978C63.0897 80.9978 80.9978 63.0897 80.9978 40.9989C80.9978 18.9081 63.0897 1 40.9989 1C18.9081 1 1 18.9081 1 40.9989C1 63.0897 18.9081 80.9978 40.9989 80.9978Z",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 90L70 70",
    stroke: "#2884FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46.4047V49.1717C61 49.6309 60.98 50.0941 60.9399 50.5532C60.3788 56.8713 55.9901 60.9998 49.6575 60.9998H32.3431C29.1368 60.9998 26.4314 59.9591 24.4876 58.0723C23.726 57.3725 23.0848 56.5505 22.5838 55.6081C23.2451 54.804 23.9866 53.9238 24.708 53.0416C25.9304 51.5778 27.1128 50.1322 27.8542 49.1918C28.9564 47.8283 31.8622 44.2392 35.8902 45.9235C36.7118 46.2643 37.4332 46.7456 38.0946 47.1666C39.7178 48.2494 40.3991 48.5702 41.5414 47.9486C42.8039 47.2669 43.6255 45.9235 44.4872 44.5199C44.9482 43.776 45.4091 43.0562 45.9101 42.3945C48.0944 39.5473 51.4611 38.7854 54.2666 40.4696C55.6694 41.3118 56.8718 42.3745 57.994 43.4552C58.2345 43.6958 58.475 43.9184 58.6954 44.1389C58.996 44.4397 59.998 45.4423 61 46.4047",
    stroke: "#2884FF",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 21H32.3425C25.549 21 21 25.7521 21 32.828V49.1715C21 51.6358 21.5611 53.8233 22.5831 55.6079C23.2445 54.8038 23.9859 53.9236 24.7074 53.0394C25.9298 51.5776 27.1121 50.132 27.8536 49.1916C28.9558 47.8281 31.8616 44.239 35.8895 45.9233C36.7112 46.2642 37.4326 46.7454 38.0939 47.1664C39.7171 48.2492 40.3985 48.57 41.5408 47.9464C42.8033 47.2667 43.6249 45.9233 44.4866 44.5177C44.9475 43.7758 45.4084 43.056 45.9094 42.3943C48.0938 39.5471 51.4604 38.7852 54.266 40.4694C55.6688 41.3116 56.8712 42.3743 57.9934 43.455C58.2339 43.6956 58.4744 43.9182 58.6948 44.1388C58.9954 44.4375 59.9974 45.4401 60.9994 46.4045V32.828C60.9994 25.7521 56.4503 21 49.6769 21Z",
    stroke: "#2884FF",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.909 34.5934C39.909 37.4105 37.5623 39.7565 34.7467 39.7565C31.9332 39.7565 29.5865 37.4105 29.5865 34.5934C29.5865 31.7782 31.9332 29.4303 34.7467 29.4303C37.5623 29.4303 39.909 31.7782 39.909 34.5934",
    stroke: "#2884FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultGallery);
export default __webpack_public_path__ + "static/media/no-result-gallery.c413455e186e1422543d8320cbd5dbae.svg";
export { ForwardRef as ReactComponent };